import { Component, OnInit } from '@angular/core';
import { EventAlbum } from '../Models/common.model';
import { FamilyeventGallaryService } from '../Services/familyevent-gallary.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-familyevent-album',
    templateUrl: './familyevent-album.component.html',
    styleUrls: [],
    providers: [FamilyeventGallaryService]
})
export class FamilyeventAlbumComponent implements OnInit {

    constructor(public dataService: FamilyeventGallaryService, private spinner: NgxSpinnerService) { }
    eventAlbum: EventAlbum[];
    notscrolly = true;
    notEmptyPost = true;
    pageNumber = 1;

    ngOnInit(): void {
        this.dataService.loadPostScrollImages(this.pageNumber).subscribe((data: EventAlbum[]) => {
            this.eventAlbum = data;
        })

    }
    onScroll() {
        if (this.notscrolly && this.notEmptyPost) {
            this.spinner.show();
            this.notscrolly = false;
            this.loadNextPost();
        }
    }
    loadNextPost() {
        try {
            this.pageNumber++;
            this.dataService.loadPostScrollImages(this.pageNumber).subscribe((data: EventAlbum[]) => {
                let newAlbum = data;
                this.spinner.hide();
                if (newAlbum.length === 0) {
                    this.notEmptyPost = false;
                }
                this.eventAlbum = this.eventAlbum.concat(newAlbum);
                this.notscrolly = true;
            })
        }
        catch (e)
        {
            console.log(e);
        }
    }
}


